<div khA11yDialog>
<div class="modal-heading modal-heading-1">
  <div class="label_name">
    <button khA11yActionButton class="kh-modal-close-button modal-close-x" (click)="closeModal()" [khA11yLabel]="'A11Y_LABEL.CLOSE' | translate">
      <fa-icon khA11yHidden [icon]="['fas', 'times']"></fa-icon>
    </button>
    <span khA11yLabelSource>{{ 'IMAGE_VIEWER_MODAL.SOLUTION' | translate }}</span>
  </div>
</div>
<div class="modal-body p-0">
  <img [src]="imageUrl" [alt]="'IMAGE_VIEWER_MODAL.SOLUTION' | translate">
</div>
<div class="modal-footer right">
  <button type="button" class="btn btn-default" data-dismiss="modal" (click)="closeModal()">{{ 'IMAGE_VIEWER_MODAL.CLOSE' | translate }}</button>
</div>
</div>
